import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react-lite';
import {useLocation, useParams, useHistory} from 'react-router-dom';
import {FormattedMessage, injectIntl} from 'react-intl';
import ImageLazy from '../../../ui/ImageLazy';
import {HostUrl} from '../../../services/core/axios-service';
import speakerImg from '../../../assets/images/defaultImages/speaker.png';
import {ReactComponent as IconLive} from "../../../assets/images/icons/icon-live.svg";
import './SpeakerCard.scss';
import styles from './SpeakerCard.module.scss'
import {Avatar} from "@mui/material";
import * as dayjs from "dayjs";
import cls from "classnames";
const SpeakerCard = observer(props => {
  const {speaker, fullImageLink, sessionsAvailable} = props;
  const location = useLocation();
  const history = useHistory();
  const {eventId, speakerId} = useParams();
  const {showSessions = true} = props;

  const openAttendeeCardOfSpeaker = () => {
    history.push({
      pathname: `/event/${eventId}/attendees/${speaker.id}`,
      state: {
        background: location.state.background,
        page: 'attendees',
        title: speaker.name,
      },
    });
  };
  const [showMore, setShowMore] = React.useState(false);

  if (!speaker) {
    return ''
  }
  return (
      <div className={styles.speakerCard} onClick={() => props.openSpeaker()}>
        <div className={styles.header}>
          <Avatar
              className={styles.image}
              src={fullImageLink ? speaker.profilePhoto : `${HostUrl}/${speaker.profilePhoto}`}
              alt={`${speaker.name} ${speaker.surname}`}
        />
          <div className={styles.details}>
            <span className={styles.name}>
              {`${speaker.name} ${speaker.surname}`}
            </span>
            <span className={styles.jobTitle}>
              {getJobTitle(speaker)}
            </span>
          </div>
        </div>
        {showSessions &&
        <div className={styles.sessions}>
          {(sessionsAvailable || [])?.slice(0, 1)?.map((session, index) => (
                <div className={styles.session} key={index}>
                  <div className={styles.details}>
                    <span className={styles.title}>{session.name}</span>
                    <span className={styles.date}>{formatTimeRange(session.std, session.edt)}</span>
                  </div>
                  <span className={styles.label}>
                   {
                      getSessionLabel(session.std, session.edt)
                   }
                  </span>
                </div>
          ))
          }
          {
            (!showMore && sessionsAvailable.slice(1) || []).length > 0 && (
                <div className={styles.moreSessions} onClick={() => setShowMore(true)}>
                  <span>+{sessionsAvailable.slice(1).length} sessions</span>
                </div>
            )
          }
          {
            showMore && (sessionsAvailable || []).slice(1).map((session, index) => (
                <div className={styles.session} key={index}>
                  <div className={styles.details}>
                    <span className={styles.title}>{session.name}</span>
                    <span className={styles.date}>{formatTimeRange(session.std, session.edt)}</span>
                  </div>
                  <span className={styles.label}>
                    {
                      getSessionLabel(session.std, session.edt)
                    }
                  </span>
                </div>
            ))
          }
        </div>
        }
      </div>
  )

  return speaker ? (
    <div className="speaker-card">
      <div className="speaker-card__details">
        <div className="speaker-card__img">
          {speaker.profilePhoto ? (
            <ImageLazy
              src={fullImageLink ? speaker.profilePhoto : `${HostUrl}/${speaker.profilePhoto}`}
              errorSrc={speakerImg}
              alt={speaker.name}
              onClick={() => (speakerId === speaker.id ? openAttendeeCardOfSpeaker() : props.openSpeaker())}
              width={100}
              height={100}
            />
          ) : (
            <img aria-hidden src={speakerImg} alt={speaker.name} width={100} height={100} />
          )}
        </div>
        <div className="speaker-card__user-info">
          <p className="speaker-card__user-label">
            <FormattedMessage id="speaker.card.label" />
          </p>
          {speakerId === speaker.id ? (
            <h4 className="speaker-card__user-name" onClick={() => openAttendeeCardOfSpeaker()} aria-hidden>
              {(Object.prototype.hasOwnProperty.call(speaker, 'name') ? `${speaker.name} ` : null) +
                (Object.prototype.hasOwnProperty.call(speaker, 'surname') ? `${speaker.surname}` : null)}
            </h4>
          ) : (
            <h4 className="speaker-card__user-name" onClick={() => props.openSpeaker()} aria-hidden>
              {(Object.prototype.hasOwnProperty.call(speaker, 'name') ? `${speaker.name} ` : null) +
                (Object.prototype.hasOwnProperty.call(speaker, 'surname') ? `${speaker.surname}` : null)}
            </h4>
          )}
          {speaker.jobTitle || speaker.company ? (
            <div className="speaker-card__user-company">
              {speaker.company}
              {speaker.company && speaker.jobTitle ? ', ' : ''}
              {speaker.jobTitle}
            </div>
          ) : null}
          {speaker.some ? (
            <div className="speaker-card__socials">
              {Object.keys(speaker.some).map(social => {
                if (speaker.some[social]) {
                  return (
                    <a
                      key={social}
                      rel="noopener noreferrer"
                      target="_blank"
                      href={speaker.some[social]}
                      className={`ui ${social} circular icon button`}
                    >
                      <i className={`${social} icon`} />
                    </a>
                  );
                }
                return null;
              })}
            </div>
          ) : null}
        </div>
      </div>
      <div className="speaker-card__sessions">
        <div className="speaker-card__sessions-wrapper" aria-hidden onClick={() => props.openSpeaker()}>
          <span className="speaker-card__sessions-count">{sessionsAvailable.length} </span>
          <FormattedMessage id="speaker.card.sessions" />
        </div>
      </div>
    </div>
  ) : null;
});

SpeakerCard.propTypes = {
  speaker: PropTypes.oneOfType([PropTypes.object]),
  sessionsAvailable: PropTypes.oneOfType([PropTypes.array]),
  fullImageLink: PropTypes.bool,
  openSpeaker: PropTypes.func,
};

SpeakerCard.defaultProps = {
  sessionsAvailable: [],
  fullImageLink: false,
  openSpeaker: () => {},
};


const formatTimeRange = (startTime, endTime) => {
  const start = dayjs(startTime);
  const end = dayjs(endTime);

  return `${start.format('D MMMM, h:mm A')} - ${end.format('h:mm A')}`;
};


const getSessionLabel = (startTime, endTime) => {
  if ( dayjs().isAfter(dayjs(startTime)) && dayjs().isBefore(dayjs(endTime))) {
    return <span className={cls(styles.label, styles.live)}><IconLive />Live</span>
  } else if(dayjs().isBefore(dayjs(startTime))) {
    return <span className={cls(styles.label, styles.upcoming)}>Upcoming</span>
  } else {
    return <span className={cls(styles.label, styles.past)}>Past</span>
  }
}

const getJobTitle = (speaker) => {
  if (!speaker?.jobTitle) {
    return 'No Information Found'
  }
  return `${speaker.jobTitle ?? ''} ${speaker.company ? `at ${speaker.company}` : ''}`
}

export default injectIntl(SpeakerCard);
